import React, { ReactElement } from 'react';
import { Tooltip } from 'antd';
import { authFeatureConstants, TOOLTIP_TEXT } from '../../../../../../../shared/constants/commonConstants';
import { ReactComponent as CloseIcon } from '../../../../../../../assets/images/svg/i_close.svg';
import { canActivate } from '../../../../../../../utils/utility';
const Facility = (props: any): ReactElement => {

  const onRemove = (): void => {
    props.onRemoveFacility(props.name);
  };

  return (
    <React.Fragment>
      <div className="badge bg-black">
        <p>{props.name}</p>
        {
          canActivate(authFeatureConstants.EDIT_HOSPITAL_PROFILE) &&
          <Tooltip title={TOOLTIP_TEXT.remove}>
            <CloseIcon className="fill-close" onClick={onRemove} style={{ verticalAlign: 'sub' }} />
          </Tooltip>
        }
      </div>
    </React.Fragment>
  );
};

export default Facility;
